<template>
  <div class="w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-4">
    <vs-card
      id="discrepancy-treemap-by-type-loading"
      class="vs-con-loading__container px-2 widget-card"
    >
      <card-header :title="$t('widget_discrepancies_by_type')">
         <feather-icon
          icon="FilterIcon"
          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
          @click="getDiscrepanciesByType"
        />

        <feather-icon
          icon="RefreshCwIcon"
          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
          @click="resetDates"
        />
      </card-header>
      <vs-row>
        <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="pr-1 mt-4">
          <datepicker
            placeholder="Start Date"
            :format="format"
            v-model="startDate"
          ></datepicker>
        </vs-col>
        <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="pl-1 mt-4">
          <datepicker
            placeholder="End Date"
            :format="format"
            v-model="endDate"
          ></datepicker>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col>
          <treemap
            :title="'Types'"
            :chartId="'treemapChart'"
            :series="treemapChart.series"
            :colors="treemapChart.colors"
          />
        </vs-col>
      </vs-row>
      <!-- Chart -->
    </vs-card>
  </div>
</template>

<script>
import Treemap from '@/views/Charts/TreemapChart.vue'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import discrepancy from '@/http/requests/discrepancy'
import loading from '@/mixins/Loading'
import CardHeader from './CardHeader.vue'

export default {
  components: {
    Treemap,
    Datepicker,
    CardHeader
  },
  mixins: [loading],
  computed: {
    isLoading() {
      return this.loading.chart
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('discrepancy-treemap-by-type-loading')
      } else {
        this.closeLoading('discrepancy-treemap-by-type-loading')
      }
    },
  },
  data() {
    return {
      startDate: moment().startOf('month').format('MM-DD-YYYY'),
      endDate: moment().format('MM-DD-YYYY'),
      format: 'MM/dd/yyyy',
      types: [],
      treemapChart: {
        series: [
          {
            data: [
              {
                x: 'Default',
                y: 0
              }
            ]
          }
        ],
        colors: [
          '#3B93A5',
          '#F7B844',
          '#ADD8C7',
          '#EC3C65',
          '#CDD7B6',
          '#C1F666',
          '#D43F97',
          '#1E5D8C',
          '#421243',
          '#7F94B0',
          '#EF6537',
          '#C0ADDB'
        ]
      },
      params: {
        client: [],
        startDate: null,
        endDate: null
      },
      loading: {
        chart: false
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getDiscrepanciesByType()
    },
    getDiscrepanciesByType() {
      this.loading.chart=true
      this.formatDatesToDB()
      discrepancy
        .getDiscrepanciesByType(this.params)
        .then((res) => {
          let types = res.data.items
          let seriesData = types.map((item) => ({
            x: item.type.charAt(0).toUpperCase() + item.type.slice(1),
            y: item.total
          }))

          this.types = types.map((item) => ({
            id: item.discrepancy_id,
            name: item.type.charAt(0).toUpperCase() + item.type.slice(1), // (item.type)|capitalize
          }))

          let series = [
            {
              data: seriesData,
            }
          ]
          this.treemapChart.series = series
          this.loading.chart=false
        })
        .catch((err) => {
          this.loading.chart=false
          console.log(err)
        })
    },
    formatDatesToDB() {
      this.params.startDate = moment(this.startDate).format('YYYY-MM-DD')
      this.params.endDate = moment(this.endDate).format('YYYY-MM-DD')
    },
    resetDates() {
      this.startDate = moment().startOf('month').format('MM-DD-YYYY')
      this.endDate = moment().format('MM-DD-YYYY')
      this.getDiscrepanciesByType()
    },
  },
}
</script>